import React, { useEffect, useRef } from 'react';
import './AdSense.css';

const AdSense = ({ 
  adClient = "ca-pub-8774537197361062",
  adSlot,
  adFormat = "auto",
  fullWidthResponsive = true,
  style = { display: 'block', minHeight: '90px' }
}) => {
  const adRef = useRef(null);

  useEffect(() => {
    const loadAd = () => {
      try {
        if (typeof window !== 'undefined' && window.adsbygoogle && adRef.current) {
          const adElements = adRef.current.querySelectorAll('.adsbygoogle');
          
          adElements.forEach((element) => {
            if (!element.getAttribute('data-adsbygoogle-status')) {
              (window.adsbygoogle = window.adsbygoogle || []).push({});
            }
          });
        }
      } catch (error) {
        console.error('AdSense loading error:', error);
      }
    };

    const timer = setTimeout(loadAd, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div ref={adRef} className="adsense-container">
      <ins
        className="adsbygoogle"
        style={style}
        data-ad-client={adClient}
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive.toString()}
      ></ins>
    </div>
  );
};

export default AdSense;